"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListItemTag = void 0;
var core_1 = require("@material-ui/core");
var styles_1 = require("@material-ui/core/styles");
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var clsx_1 = __importDefault(require("clsx"));
var useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        root: {
            borderRadius: '0.125rem',
            padding: 0,
            paddingLeft: theme.spacing(0.5),
            paddingRight: theme.spacing(0.5) - 1,
            overflow: 'hidden',
            backgroundColor: function (props) {
                return props.backgroundColor ||
                    (theme.palette.type === 'dark' ? theme.palette.primary.dark : theme.palette.primary.main);
            },
            color: function (props) {
                return props.fontColor ||
                    theme.palette.getContrastText(props.backgroundColor ||
                        (theme.palette.type === 'dark' ? theme.palette.primary.dark : theme.palette.primary.main));
            },
            cursor: function (props) { return (props.onClick ? 'pointer' : 'inherit'); },
            display: 'inline-block',
            flip: false, // letter-spacing doesn't flip for RTL, so neither shall our padding hack to offset it
        },
        noVariant: {
            fontWeight: 700,
            letterSpacing: 1,
            fontSize: "0.625rem",
            lineHeight: "1rem",
            height: "1rem",
        },
    });
});
var ListItemTagRender = function (props, ref) {
    var _a;
    var userClasses = props.classes, label = props.label, variant = props.variant, 
    // ignore unused vars so that we can do prop transferring to the root element
    /* eslint-disable @typescript-eslint/no-unused-vars */
    fontColor = props.fontColor, backgroundColor = props.backgroundColor, 
    /* eslint-enable @typescript-eslint/no-unused-vars */
    otherTypographyProps = __rest(props, ["classes", "label", "variant", "fontColor", "backgroundColor"]);
    var defaultClasses = useStyles(props);
    var rootUserClass = userClasses.root, otherUserClasses = __rest(userClasses, ["root"]);
    return (react_1.default.createElement(core_1.Typography, __assign({ ref: ref, classes: __assign({ root: clsx_1.default(defaultClasses.root, rootUserClass, (_a = {}, _a[defaultClasses.noVariant] = !variant, _a)) }, otherUserClasses), variant: variant || 'overline', "data-test": 'list-item-tag' }, otherTypographyProps), label));
};
/**
 * [ListItemTag](https://pxblue-components.github.io/react/?path=/info/components-list-item-tag--get-read-me-story) component
 *
 * `<ListItemTag>` is a text item with a colored background and rounded corners that is used to tag lists.
 */
exports.ListItemTag = react_1.default.forwardRef(ListItemTagRender);
exports.ListItemTag.propTypes = {
    label: prop_types_1.default.string.isRequired,
    backgroundColor: prop_types_1.default.string,
    fontColor: prop_types_1.default.string,
};
exports.ListItemTag.defaultProps = {
    noWrap: true,
    display: 'inline',
    classes: {},
};
exports.ListItemTag.displayName = 'ListItemTag';
